import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import TableSalesManagement from "./tableSalesManagement";
import TableHonor from "./tableHonor";
import TableStatement from "./tableStatement";

export default function SalesManagement() {
  return (
    <Box
      w={{ base: "100%" }}
      backgroundColor="var(--color-backgroundmain)"
      p={{ base: "24px 16px 16px" }}
    >
      <Flex gap={"16px"}>
        <Box w={"66.36141636%"}>
          <TableSalesManagement />
          <Box mt={"16px"}>
            <TableStatement />
          </Box>
        </Box>
        <Box w={"32.66178266%"}>
          <TableHonor />
        </Box>
      </Flex>
    </Box>
  );
}
